/**
 * Cloudflare Images URLs for static assets
 *
 * Generated by migrate-static-assets script
 * Do NOT edit manually - run the migration script to regenerate
 */

const IMAGE_BASE = 'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static';

export const CLOUDFLARE_STATIC_ASSETS = {
  // Hero backgrounds (homepage, 404, FB landing)
  HERO_BACK_1: `${IMAGE_BASE}/hero_back_1/public`,
  HERO_BACK_2: `${IMAGE_BASE}/hero_back_2/public`,
  HERO_BACK_3: `${IMAGE_BASE}/hero_back_3/public`,
  HERO_BACK_4: `${IMAGE_BASE}/hero_back_4/public`,

  // Document header (Visual Report PDFs)
  DOCUMENT_HEADER: `${IMAGE_BASE}/document_header/public`,

  // Page hero images (public pages)
  HERO_PAGE_1:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_1/public',
  HERO_PAGE_2:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_2/public',
  HERO_PAGE_3:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_3/public',
  HERO_PAGE_4:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_4/public',
  HERO_PAGE_5:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_5/public',
  HERO_PAGE_6:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_6/public',
  HERO_PAGE_7:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_7/public',
  HERO_PAGE_8:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_8/public',
  HERO_PAGE_9:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_9/public',
  HERO_PAGE_10:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_10/public',
  HERO_PAGE_11:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_11/public',
  HERO_PAGE_12:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_12/public',
  HERO_PAGE_13:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_13/public',
  HERO_PAGE_14:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_14/public',
  HERO_PAGE_15:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_15/public',
  HERO_PAGE_16:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_16/public',
  HERO_PAGE_17:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_17/public',
  HERO_PAGE_18:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_18/public',
  HERO_PAGE_19:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_19/public',
  HERO_PAGE_20:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_20/public',
  HERO_PAGE_21:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_21/public',
  HERO_PAGE_22:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_22/public',
  HERO_PAGE_23:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_23/public',
  HERO_PAGE_24:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_24/public',
  HERO_PAGE_25:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_25/public',
  HERO_PAGE_26:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_26/public',
  HERO_PAGE_27:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_27/public',
  HERO_PAGE_28:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_28/public',
  HERO_PAGE_29:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_29/public',
  HERO_PAGE_30:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_30/public',
  HERO_PAGE_31:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_31/public',
  HERO_PAGE_32:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_32/public',
  HERO_PAGE_33:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_33/public',
  HERO_PAGE_34:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_34/public',
  HERO_PAGE_35:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_35/public',
  HERO_PAGE_36:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_36/public',
  HERO_PAGE_37:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_37/public',
  HERO_PAGE_38:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_38/public',
  HERO_PAGE_39:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_39/public',
  HERO_PAGE_40:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_40/public',
  HERO_PAGE_41:
    'https://imagedelivery.net/5wuZAH_9vffMSAcfS9LbRw/stratplan/static/hero_page_41/public',

  // Logos
  LOGO_ICON: `${IMAGE_BASE}/logo_icon/public`,
  LOGO_LIGHT: `${IMAGE_BASE}/logo_light/public`,
  LOGO_DARK: `${IMAGE_BASE}/logo_dark/public`,
} as const;

// Helper function to get optimized version (only works for non-SVG images)
export function getOptimizedStatic(
  url: string,
  options?: { width?: number; height?: number; fit?: string; format?: string }
) {
  // SVG files should use original URL
  if (url.includes('.svg')) {
    return url;
  }

  // For raster images, use flexible variants
  const params: string[] = [];
  if (options?.width) params.push(`w=${options.width}`);
  if (options?.height) params.push(`h=${options.height}`);
  if (options?.fit) params.push(`fit=${options.fit}`);
  if (options?.format) params.push(`format=${options.format}`);

  if (params.length === 0) return url;

  const variant = params.join(',');
  return url.replace(/\/public$/, `/${variant}`);
}

/** Breakpoints (px) for responsive hero images */
const HERO_BREAKPOINTS = { mobile: 640, tablet: 1024, desktop: 1920 } as const;

/** Get responsive width for hero backgrounds based on viewport */
export function getResponsiveHeroWidth(viewportWidth: number): number {
  if (viewportWidth < 640) return HERO_BREAKPOINTS.mobile;
  if (viewportWidth < 1024) return HERO_BREAKPOINTS.tablet;
  return HERO_BREAKPOINTS.desktop;
}

/** Get a responsive hero URL with viewport-aware width and format=auto */
export function getResponsiveHeroUrl(url: string, viewportWidth: number): string {
  const width = getResponsiveHeroWidth(viewportWidth);
  return getOptimizedStatic(url, { width, format: 'auto' });
}

/** Map public page path to page hero image key (HERO_PAGE_1 .. HERO_PAGE_41) */
export const PAGE_HERO_IMAGE_MAP: Record<string, keyof typeof CLOUDFLARE_STATIC_ASSETS> = {
  '/about': 'HERO_PAGE_1',
  '/careers': 'HERO_PAGE_2',
  '/contact': 'HERO_PAGE_3',
  '/privacy': 'HERO_PAGE_4',
  '/pricing': 'HERO_PAGE_5',
  '/blog': 'HERO_PAGE_6',
  '/strategic-framework': 'HERO_PAGE_7',
  '/foundation': 'HERO_PAGE_8',
  '/foundation/vision-statement': 'HERO_PAGE_9',
  '/foundation/mission-statement': 'HERO_PAGE_10',
  '/foundation/core-values': 'HERO_PAGE_11',
  '/foundation/strategic-objectives': 'HERO_PAGE_12',
  '/external-assessment': 'HERO_PAGE_13',
  '/external-assessment/porters-five-forces': 'HERO_PAGE_14',
  '/external-assessment/pestel-analysis': 'HERO_PAGE_15',
  '/external-assessment/market-analysis': 'HERO_PAGE_16',
  '/external-assessment/competitive-positioning': 'HERO_PAGE_17',
  '/internal-assessment': 'HERO_PAGE_18',
  '/internal-assessment/swot-analysis': 'HERO_PAGE_19',
  '/internal-assessment/core-competencies': 'HERO_PAGE_20',
  '/internal-assessment/resource-audit': 'HERO_PAGE_21',
  '/strategy-formulation': 'HERO_PAGE_22',
  '/strategy-formulation/competitive-strategy': 'HERO_PAGE_23',
  '/strategy-formulation/growth-strategy': 'HERO_PAGE_24',
  '/strategy-formulation/strategic-initiatives': 'HERO_PAGE_25',
  '/execution-monitoring': 'HERO_PAGE_26',
  '/execution-monitoring/okrs-kpis': 'HERO_PAGE_27',
  '/execution-monitoring/strategic-cadence': 'HERO_PAGE_28',
  '/execution-monitoring/continuous-improvement': 'HERO_PAGE_29',
  '/execution-monitoring/accountability-ownership': 'HERO_PAGE_30',
  '/ai-insights': 'HERO_PAGE_31',
  '/team-collaboration': 'HERO_PAGE_32',
  '/performance-tracking': 'HERO_PAGE_33',
  '/company/setup': 'HERO_PAGE_34',
  '/health-check': 'HERO_PAGE_32',
};

/** Get page hero image URL for a path (defaults to HERO_PAGE_1 if unknown) */
export function getPageHeroImageUrl(pathname: string): string {
  const key = PAGE_HERO_IMAGE_MAP[pathname] ?? 'HERO_PAGE_1';
  return CLOUDFLARE_STATIC_ASSETS[key];
}
